export default function getResource(label, vars = []) {
    const resources = {
        marketingTitle: 'Select country and language for updates.',
        marketingLanguage: 'Marketing Language',
        zipCode: 'ZIP Code',
        postalCode: 'Postal Code',
        zipCodeLabel: 'ZIP Code:',
        postalCodeLabel: 'Postal Code:',
        none: 'None',
        enterZipCode: 'Enter your ZIP code to hear about store events near you.',
        enterPostalCode: 'Enter your postal code to hear about store events near you.',
        usEnglish: 'US - English',
        canadaEnglish: 'Canada - English',
        canadaFrench: 'Canada - Français',
        pleaseEnterZipCode: 'Please enter a ZIP code.',
        pleaseEnterPostalCode: 'Please enter a postal code.',
        invalidZipCode: 'Not a Valid Zip Code. Please try again.',
        invalidPostalCode: 'Please enter a valid postal code.',
        cancel: 'Cancel',
        save: 'Save',
        edit: 'Edit',
        noCountryOrLanguageSelected: 'No country or language selected.',
        canadaLangCountryCopy: 'Sephora Beauty Canada, Inc. (160 Bloor St. East Suite 1100 Toronto, ON M4W 1B9 | Canada, sephora.ca) is requesting consent on its own behalf and on behalf of Sephora USA, Inc. (350 Mission Street, Floor 7, San Francisco, CA 94105, sephora.com). You may withdraw your consent at any time.'
    };
    return resources[label];
}
